import { CardContentWrapper } from '@/src/pages/EOC1Compliance/components/Card.styled';
import { Card, Heading4, P, theme } from '@ovotech/element-v5';
import styled from 'styled-components';
import { mqSmallDown } from '@/src/utils/mediaQuery';

export const FullWidthContentWrapper = styled(CardContentWrapper)`
  > * {
    flex-grow: 1;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${theme.space['600']} ${theme.space['400']};
  ${mqSmallDown(`
     padding: ${theme.space['200']};
  `)}
`;

export const TabButton = styled.button<{ isActive: boolean }>`
  background: ${props =>
    props.isActive ? theme.color.brand.onBrand : 'transparent'};
  color: ${theme.color.brand.dark};
  font-weight: ${props =>
    props.isActive ? theme.font.weight.bold : theme.font.weight.book};
  border-radius: 50px;
  padding: ${theme.space['200']} ${theme.space['400']};
  border: none;
  cursor: pointer;
  font-family: inherit;
  flex-grow: 1;
`;

export const TabButtonGroup = styled.div`
  display: flex;
  gap: ${theme.space['200']};
  background-color: ${theme.color.surface.dim};
  border-radius: 50px;
  padding: ${theme.space['100']};
  width: 100%;
`;

export const MainContentCard = styled(Card)`
  background-color: ${theme.color.surface.surface};
  display: flex;
  flex-direction: column;
  gap: ${theme.space['600']};
  align-self: stretch;
  border-radius: ${theme.space['0']};
  outline: none;
  padding: 0;
  border: none;
`;

export const HelpText = styled(P)`
  line-height: ${theme.font.lineHeight.md};
  font-weight: 450;
`;

// --- Product selection header ---
// Title + body on the left, plan toggle on the right; stacks on small screens.
export const PlanHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.space['600']};
  padding: ${theme.space['600']} ${theme.space['400']};
  ${mqSmallDown(`
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.space['400']};
    padding: ${theme.space['400']} ${theme.space['200']};
  `)}
`;

export const PlanHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space['200']};
`;

export const PlanHeaderTitle = styled(Heading4)`
  color: ${theme.color.brand.dark};
  margin: 0;
`;

export const PlanHeaderBody = styled(P)`
  color: ${theme.color.brand.dark};
  margin: 0;
`;

// Caps the two-segment toggle so it stays compact beside the header text on
// desktop, rather than stretching across the full row.
const TOGGLE_MAX_WIDTH = '340px';

// Keeps the toggle compact on the right on desktop, full-width when stacked.
export const PlanToggleWrapper = styled.div`
  flex: 0 0 auto;
  width: 100%;
  max-width: ${TOGGLE_MAX_WIDTH};
  ${mqSmallDown(`
    max-width: none;
  `)}
`;

// --- Grouped plans (partner + standard plans on the same page) ---
// Extra margin-top on top of MainContentCard's own gap: the "OVO plans"
// group needs more breathing room above it than the standard section gap gives.
export const GroupedPlansContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space['600']};
  margin-top: ${theme.space['400']};
`;

export const PlanGroupSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space['400']};
`;

export const PlanGroupHeading = styled(Heading4)`
  color: ${theme.color.brand.dark};
  margin: 0;
  padding: 0;
`;

// Insets the Kwik Fit notice to the card's content edge.
export const KwikFitNoticeWrapper = styled.div`
  padding-inline: ${theme.space['400']};

  /* Flag off - the notice renders nothing, so don't leave its gap behind. */
  &:empty {
    display: none;
  }

  /* The header row's own bottom padding already separates this from the
     toggle; drop the card's gap on top of it so the notice sits with the
     plans it describes rather than floating mid-card. */
  &:not(:first-child) {
    margin-top: -${theme.space['600']};
  }
`;
